import { render } from "./ManageAttendees.vue?vue&type=template&id=aa3106fc"
import script from "./ManageAttendees.vue?vue&type=script&lang=js"
export * from "./ManageAttendees.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__